var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOkkoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190.4 108.6",
    style: {
      enableBackground: "new 0 0 190.4 108.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.3,28.3c-9.4,0-17,7.6-17,17c0,9.4,7.6,17,17,17s17-7.6,17-17C66.3,35.9,58.7,28.3,49.3,28.3z M49.3,54.8 c-5.2,0-9.4-4.2-9.4-9.4c0-5.2,4.2-9.4,9.4-9.4s9.4,4.2,9.4,9.4C58.8,50.5,54.5,54.8,49.3,54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.2,22.3c0,2.2-1.7,4-3.9,4c-2.1,0-3.9-1.8-3.9-4c0-2.2,1.7-4,3.9-4C51.4,18.3,53.2,20.1,53.2,22.3 L53.2,22.3z M63.3,22.3c0,2.2-1.7,4-3.9,4c-2.1,0-3.9-1.8-3.9-4c0-2.2,1.7-4,3.9-4C61.6,18.3,63.3,20.1,63.3,22.3L63.3,22.3z  M39.2,26.3c-2.1,0-3.9-1.8-3.9-4c0-2.2,1.7-4,3.9-4s3.9,1.8,3.9,4C43.1,24.5,41.3,26.3,39.2,26.3L39.2,26.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.7,81.1c0,0.6-0.1,1.2-0.3,1.8c-0.2,0.5-0.5,1-0.9,1.4C40,84.7,39.5,85,39,85.2s-1.1,0.3-1.8,0.3 s-1.2-0.1-1.8-0.3s-1-0.5-1.4-0.9c-0.4-0.4-0.7-0.9-0.9-1.4s-0.3-1.1-0.3-1.8s0.1-1.2,0.3-1.8s0.5-1,0.9-1.4 c0.4-0.4,0.9-0.7,1.4-0.9s1.1-0.3,1.8-0.3s1.2,0.1,1.8,0.3s1,0.5,1.4,0.9c0.4,0.4,0.7,0.9,0.9,1.4C41.5,79.8,41.7,80.4,41.7,81.1z  M40.7,81.1c0-0.5-0.1-1-0.2-1.4s-0.4-0.8-0.7-1.2c-0.3-0.3-0.7-0.6-1.1-0.8c-0.4-0.2-0.9-0.3-1.5-0.3s-1,0.1-1.5,0.3 c-0.4,0.2-0.8,0.5-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.2s-0.2,0.9-0.2,1.4c0,0.5,0.1,1,0.2,1.4s0.4,0.8,0.7,1.2 c0.3,0.3,0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.3,1.5,0.3s1-0.1,1.5-0.3c0.4-0.2,0.8-0.5,1.1-0.8c0.3-0.3,0.5-0.7,0.7-1.2 S40.7,81.6,40.7,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.2,76.8h0.9v3.7h4.6v-3.7h0.9v8.5h-0.9v-4h-4.6v4h-0.9V76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.6,85.3h-0.9l3.7-8.5h0.8l3.6,8.5h-1l-3.1-7.4L51.6,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,85.3h-0.9l3.7-8.5h0.8l3.6,8.5h-1l-0.9-2.2h-4.4L59.6,85.3z M60.8,82.3h3.7l-1.9-4.5L60.8,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.6,76.8h1.1v8.5h-0.9V78h0l-4.9,7.3h-1.1v-8.5h0.9v7.2h0L73.6,76.8z M69.8,74.5c0.1,0.3,0.3,0.5,0.5,0.7 c0.3,0.2,0.6,0.3,1,0.3s0.7-0.1,1-0.3c0.3-0.2,0.4-0.4,0.5-0.7l0.6,0.3c-0.1,0.2-0.2,0.4-0.3,0.5s-0.3,0.3-0.5,0.4 c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.5,0.1-0.8,0.1s-0.5,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.3-0.3-0.5-0.4 s-0.2-0.3-0.3-0.5L69.8,74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.8,76.8h0.9v3.7h4.6v-3.7h0.9v8.5h-0.9v-4h-4.6v4h-0.9V76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.3,82.8h-2.7v-0.7h2.7V82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.8,85.3v-8.5h0.9v3.6c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0.1l3.2-3.7h0.9l-3.3,3.9c1,0.3,1.8,0.8,2.3,1.6 c0.5,0.8,0.9,1.8,1.1,3h-0.9c-0.1-0.7-0.3-1.4-0.5-1.9c-0.2-0.5-0.5-1-0.9-1.3s-0.8-0.6-1.3-0.7c-0.5-0.2-1.1-0.2-1.8-0.2v4.1 H88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.8,84.1l4.9-7.2h1.1v8.5H103V78h0L98,85.3h-1.1v-8.5h0.9L97.8,84.1L97.8,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.9,76.8h0.9v3.7h4.6v-3.7h0.9v8.5h-0.9v-4h-4.6v4h-0.9V76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.7,81.1c0,0.6-0.1,1.2-0.3,1.8c-0.2,0.5-0.5,1-0.9,1.4c-0.4,0.4-0.9,0.7-1.4,0.9s-1.1,0.3-1.8,0.3 s-1.2-0.1-1.8-0.3s-1-0.5-1.4-0.9c-0.4-0.4-0.7-0.9-0.9-1.4s-0.3-1.1-0.3-1.8s0.1-1.2,0.3-1.8s0.5-1,0.9-1.4 c0.4-0.4,0.9-0.7,1.4-0.9s1.1-0.3,1.8-0.3s1.2,0.1,1.8,0.3s1,0.5,1.4,0.9c0.4,0.4,0.7,0.9,0.9,1.4 C122.6,79.8,122.7,80.4,122.7,81.1z M121.8,81.1c0-0.5-0.1-1-0.2-1.4s-0.4-0.8-0.7-1.2c-0.3-0.3-0.7-0.6-1.1-0.8 c-0.4-0.2-0.9-0.3-1.5-0.3s-1,0.1-1.5,0.3c-0.4,0.2-0.8,0.5-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.2s-0.2,0.9-0.2,1.4 c0,0.5,0.1,1,0.2,1.4s0.4,0.8,0.7,1.2c0.3,0.3,0.7,0.6,1.1,0.8c0.4,0.2,0.9,0.3,1.5,0.3s1-0.1,1.5-0.3c0.4-0.2,0.8-0.5,1.1-0.8 c0.3-0.3,0.5-0.7,0.7-1.2S121.8,81.6,121.8,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127,85.3h-0.9v-7.7h-2.8v-0.8h6.6v0.8H127V85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.8,84.6h4.5v0.8h-5.4v-8.5h5.3v0.8h-4.4v2.9h4.1v0.8h-4.1V84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.8,85.3h-0.9l3.7-8.5h0.8l3.6,8.5h-1l-0.9-2.2h-4.4L137.8,85.3z M139,82.3h3.7l-1.9-4.5L139,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.7,85.3h-0.9v-7.7H145v-0.8h6.6v0.8h-2.8V85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.6,76.8h2.4c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.7,0.2,0.9,0.4c0.3,0.2,0.4,0.4,0.6,0.7c0.1,0.3,0.2,0.6,0.2,1 c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.5-0.6,0.7c-0.3,0.2-0.6,0.3-0.9,0.4c-0.4,0.1-0.8,0.1-1.2,0.1h-1.5v3.9h-0.9V76.8z  M153.5,80.6h1.5c0.7,0,1.2-0.1,1.5-0.4c0.4-0.3,0.5-0.6,0.5-1.2c0-0.5-0.2-0.9-0.5-1.2c-0.4-0.2-0.9-0.4-1.5-0.4h-1.5V80.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.3,28.3c-9.4,0-17,7.6-17,17c0,9.4,7.6,17,17,17s17-7.6,17-17C157.3,35.9,149.7,28.3,140.3,28.3z  M140.3,54.8c-5.2,0-9.4-4.2-9.4-9.4c0-5.2,4.2-9.4,9.4-9.4s9.4,4.2,9.4,9.4C149.8,50.5,145.5,54.8,140.3,54.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "82.6,47.2 95.9,62.3 86,62.3 78.1,53.8 76.1,56.8 76.1,62.3 68.3,62.3 68.3,54.4 68.3,42.9 68.3,31.3  68.3,18.6 76.1,18.6 76.1,39.9 76.1,43 77.2,41.2 86.2,28.3 95.1,28.3 82.6,47.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "112.6,47.2 125.9,62.3 116,62.3 108.1,53.8 106.1,56.8 106.1,62.3 98.3,62.3 98.3,54.4 98.3,42.9  98.3,31.3 98.3,18.6 106.1,18.6 106.1,39.9 106.1,43 107.2,41.2 116.2,28.3 125.1,28.3 112.6,47.2  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkkoLogo);
export default __webpack_public_path__ + "static/media/Okko-Logo.c660e2cb566f7a843cb3b0a44316198b.svg";
export { ForwardRef as ReactComponent };